<div class="flex flex-column mt-2">
    <div class="text-base font-semibold text-center">
        <app-translate key="IFRAME_PAYMENT_INSTRUCTION"></app-translate>
    </div>
    <div class="text-base text-center mt-2">
        <app-translate key="IFRAME_PAYMENT_RETURN"></app-translate>
    </div>
    @if (!iframeStarted) {
    <div class="my-4">
        <p-button [label]="languageService.getTranslation('BEGIN_PAYMENT')" [outlined]="true"
            styleClass="p-button-lg w-full" (onClick)="onBeginPaymentClicked()" />
    </div>
    } @else {
    <div class="iframe-payment-container my-4">
        @if (iframeLoading) {
        <div class="iframe-loading-overlay">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>
        }
        <iframe class="border-none w-full" [src]="iframeSafeUrl" [height]="iframeHeight" title="Provider payment"
            (load)="onIframeLoaded()"></iframe>
    </div>
    }
    <div class="text-base text-center mb-3">
        <span><app-translate key="HAVING_TROUBLE_VIEWING_PAYMENT"></app-translate> </span>
        <p-button [label]="languageService.getTranslation('CLICK_HERE')" [link]="true"
            styleClass="link-out-button p-0 vertical-align-baseline font-semibold outline-none" (onClick)="onOpenExternalPaymentDialog()" />
    </div>
    <div class="text-base text-center mb-3">
        <strong><app-translate key="NOTE"></app-translate>: </strong>
        <app-translate key="IFRAME_PAYMENT_NOTE"></app-translate>
    </div>
</div>

<app-confirm-popup
    [header]="languageService.getTranslation('EXTERNAL_PAYMENT_HEADER')"
    [title]="languageService.getTranslation('EXTERNAL_PAYMENT_MESSAGE')"
    [buttonLabel]="languageService.getTranslation('CONTINUE')"
    [buttonLabel2]="languageService.getTranslation('CANCEL')"
    [(isVisible)]="showExternalPaymentDialog"
    (Result)="onExternalPaymentModalResult($event)">
</app-confirm-popup>
